module.exports = __webpack_public_path__ + "media/images/emblems/Walterswil-blason-45c0e23bdecded6d158d8a09dbbd9191.png";